import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { Modal, Offcanvas } from 'bootstrap';
import { useToast } from 'vue-toastification';
import _ from 'lodash';

import LayoutHome from '@/components/Layout/Home.vue';
import LayoutMain from '@/components/Layout/Main.vue';
import LayoutClean from '@/components/Layout/Clean.vue';

import AuthSignup from '@/views/Auth/Signup.vue';
import AuthLogin from '@/views/Auth/Login.vue';
import AuthForgot from '@/views/Auth/Forgot.vue';
import AuthRecover from '@/views/Auth/Recover.vue';
import AuthLogout from '@/views/Auth/Logout.vue';

import AccountSettingIndex from '@/views/Account/Setting/Index.vue';
import AccountSettingPassword from '@/views/Account/Setting/Password.vue';

import HomeIndex from '@/views/Home/Index.vue';
import CustomerIndex from '@/views/Customer/Index.vue';
import PropostalForm from '@/views/Propostal/Form.vue';
import SaleIndex from '@/views/Sale/Index.vue';
import BalanceShow from '@/views/Balance/Show.vue';

import CompanySelect from '@/views/Company/Select.vue';
import CompanyCreate from '@/views/Company/Create.vue';

import InvitationIndex from '@/views/Invitation/Index.vue';

import CompanyAdminHome from '@/views/Company/Admin/Home.vue';

import CompanyAdminGroupIndex from '@/views/Company/Admin/Group/Index.vue';
import CompanyAdminGroupForm from '@/views/Company/Admin/Group/Form.vue';

import CompanyAdminCustomerIndex from '@/views/Company/Admin/Customer/Index.vue';
import CompanyAdminCustomerImport from '@/views/Company/Admin/Customer/Import.vue';

import CompanyAdminSaleIndex from '@/views/Company/Admin/Sale/Index.vue';
import CompanyAdminSaleAssign from '@/views/Company/Admin/Sale/Assign.vue';

import CompanyAdminGoalIndex from '@/views/Company/Admin/Goal/Index.vue';
import CompanyAdminGoalForm from '@/views/Company/Admin/Goal/Form.vue';
import CompanyAdminGoalStat from '@/views/Company/Admin/Goal/Stat.vue';

import CompanyAdminGoalPeriodIndex from '@/views/Company/Admin/Goal/Period/Index.vue';
import CompanyAdminGoalPeriodForm from '@/views/Company/Admin/Goal/Period/Form.vue';

import CompanyAdminUserIndex from '@/views/Company/Admin/User/Index.vue';
import CompanyAdminUserForm from '@/views/Company/Admin/User/Form.vue';

import CompanyAdminReportGeneral from '@/views/Company/Admin/Report/General.vue';

import CompanyAdminSettingIndex from '@/views/Company/Admin/Setting/Index.vue';
import CompanyAdminSettingConfig from '@/views/Company/Admin/Setting/Config.vue';
import CompanyAdminSettingExchange from '@/views/Company/Admin/Setting/Exchange.vue';

import CompanyAdminBalanceIndex from '@/views/Company/Admin/Balance/Index.vue';
import CompanyAdminBalanceShow from '@/views/Company/Admin/Balance/Show.vue';

import CompanyAdminSynchronizerIndex from '@/views/Company/Admin/Synchronizer/Index.vue';
import CompanyAdminSynchronizerForm from '@/views/Company/Admin/Synchronizer/Form.vue';
import CompanyAdminSynchronizerToken from '@/views/Company/Admin/Synchronizer/Token.vue';

import CompanyLeaderCustomerIndex from '@/views/Company/Leader/Customer/Index.vue';

import NotFound from '@/views/NotFound.vue';

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/auth',
			meta: { needUser: false },
			component: LayoutClean,
			children: [
				{
					path: 'signup',
					name: 'auth.signup',
					component: AuthSignup
				},
				{
					path: 'login',
					name: 'auth.login',
					component: AuthLogin
				},
				{
					path: 'forgot',
					name: 'auth.forgot',
					component: AuthForgot
				},
				{
					path: 'recover',
					name: 'auth.recover',
					component: AuthRecover
				},
				{
					path: 'logout',
					name: 'auth.logout',
					meta: { needUser: true },
					component: AuthLogout
				}
			]
		},
		{
			path: '/',
			meta: { needUser: true, breadcrumb: 'Mi cuenta' },
			component: LayoutHome,
			children: [
				{
					path: 'home',
					name: 'home',
					component: HomeIndex
				},
				{
					path: 'customer',
					meta: { breadcrumb: 'Clientes' },
					children: [
						{
							path: '',
							name: 'customer.index',
							component: CustomerIndex
						},
						{
							path: ':id',
							children: [
							]
						}
					]
				},
				{
					path: 'propostal',
					meta: { breadcrumb: 'Propuesta' },
					children: [
						{
							path: 'form',
							props: true,
							name: 'propostal.form',
							component: PropostalForm
						}
					]
				},
				{
					path: 'sale',
					meta: { breadcrumb: 'Ventas' },
					children: [
						{
							path: '',
							name: 'sale.index',
							component: SaleIndex
						}
					]
				},
				{
					path: 'balance',
					meta: { breadcrumb: 'Balance' },
					children: [
						{
							path: ':id',
							props: true,
							name: 'balance.show',
							component: BalanceShow
						}
					]
				}
			]
		},
		{
			path: '/account',
			meta: { needUser: true, breadcrumb: 'Cuenta' },
			component: LayoutClean,
			children: [
				{
					path: 'setting',
					meta: { breadcrumb: 'Configuración' },
					children: [
						{
							path: '',
							name: 'account.setting.index',
							component: AccountSettingIndex
						},
						{
							path: 'password',
							name: 'account.setting.password',
							component: AccountSettingPassword
						}
					]
				}
			]
		},
		{
			path: '/company',
			meta: { needUser: true },
			component: LayoutClean,
			children: [
				{
					path: 'select',
					name: 'company.select',
					meta: { needUser: true },
					component: CompanySelect
				},
				{
					path: 'create',
					name: 'company.create',
					meta: { needUser: true },
					component: CompanyCreate
				}
			]
		},
		{
			path: '/invitation',
			meta: { needUser: true },
			component: LayoutClean,
			children: [
				{
					path: ':uuid',
					props: true,
					name: 'invitation.index',
					component: InvitationIndex
				}
			]
		},
		{
			path: '/:company_id',
			props: true,
			meta: { needUser: true, companyArea: true, breadcrumb: 'Empresa' },
			component: LayoutMain,
			children: [
				{
					path: '',
					name: 'company.admin.home',
					component: CompanyAdminHome
				},
				{
					path: 'admin',
					meta: { roles: ['admin'] },
					children: [
						{
							path: 'group',
							meta: { breadcrumb: 'Grupos' },
							children: [
								{
									path: '',
									name: 'company.admin.group.index',
									component: CompanyAdminGroupIndex
								},
								{
									path: 'create',
									name: 'company.admin.group.create',
									component: CompanyAdminGroupForm
								},
								{
									path: ':id',
									props: true,
									name: 'company.admin.group.form',
									component: CompanyAdminGroupForm
								}
							]
						},
						{
							path: 'customer',
							meta: { breadcrumb: 'Clientes' },
							children: [
								{
									path: '',
									name: 'company.admin.customer.index',
									component: CompanyAdminCustomerIndex
								},
								{
									path: 'import',
									name: 'company.admin.customer.import',
									component: CompanyAdminCustomerImport
								}
							]
						},
						{
							path: 'sale',
							meta: { breadcrumb: 'Ventas' },
							children: [
								{
									path: '',
									name: 'company.admin.sale.index',
									component: CompanyAdminSaleIndex
								},
								{
									path: 'assign',
									name: 'company.admin.sale.assign',
									component: CompanyAdminSaleAssign
								}
							]
						},
						{
							path: 'user',
							meta: { breadcrumb: 'Usuarios' },
							children: [
								{
									path: '',
									name: 'company.admin.user.index',
									component: CompanyAdminUserIndex
								},
								{
									path: ':id',
									props: true,
									name: 'company.admin.user.form',
									component: CompanyAdminUserForm
								}
							]
						},
						{
							path: 'balance',
							meta: { breadcrumb: 'Balances' },
							children: [
								{
									path: '',
									name: 'company.admin.balance.index',
									component: CompanyAdminBalanceIndex
								},
								{
									path: ':id',
									props: true,
									name: 'company.admin.balance.show',
									component: CompanyAdminBalanceShow
								}
							]
						},
						{
							path: 'synchronizer',
							meta: { breadcrumb: 'Conexiones' },
							children: [
								{
									path: '',
									name: 'company.admin.synchronizer.index',
									component: CompanyAdminSynchronizerIndex
								},
								{
									path: 'create',
									name: 'company.admin.synchronizer.create',
									component: CompanyAdminSynchronizerForm
								},
								{
									path: ':id',
									props: true,
									children: [
										{
											path: '',
											props: true,
											name: 'company.admin.synchronizer.form',
											component: CompanyAdminSynchronizerForm
										},
										{
											path: 'token',
											props: true,
											name: 'company.admin.synchronizer.token',
											component: CompanyAdminSynchronizerToken
										}
									]
								}
							]
						},
						{
							path: 'goal',
							meta: { breadcrumb: 'Metas' },
							children: [
								{
									path: '',
									name: 'company.admin.goal.index',
									component: CompanyAdminGoalIndex
								},
								{
									path: 'create',
									name: 'company.admin.goal.create',
									component: CompanyAdminGoalForm
								},
								{
									path: ':id',
									props: true,
									children: [
										{
											path: '',
											props: true,
											name: 'company.admin.goal.form',
											component: CompanyAdminGoalForm
										},
										{
											path: 'stat',
											props: true,
											name: 'company.admin.goal.stat',
											component: CompanyAdminGoalStat
										},
										{
											path: 'period',
											meta: { breadcrumb: 'Períodos' },
											children: [
												{
													path: '',
													props: true,
													name: 'company.admin.goal.period.index',
													component: CompanyAdminGoalPeriodIndex
												},
												{
													path: 'create',
													props: true,
													name: 'company.admin.goal.period.create',
													component: CompanyAdminGoalPeriodForm
												},
												{
													path: ':goal_period_id',
													children: [
														{
															path: '',
															props: true,
															name: 'company.admin.goal.period.form',
															component: CompanyAdminGoalPeriodForm
														}
													]
												}
											]
										}
									]
								}
							]
						},
						{
							path: 'report',
							meta: { breadcrumb: 'Estadísticas' },
							children: [
								{
									path: 'general',
									name: 'company.admin.report.general',
									component: CompanyAdminReportGeneral
								}
							]
						},
						{
							path: 'setting',
							meta: { breadcrumb: 'Configuración' },
							children: [
								{
									path: '',
									name: 'company.admin.setting.index',
									component: CompanyAdminSettingIndex
								},
								{
									path: 'config',
									name: 'company.admin.setting.config',
									component: CompanyAdminSettingConfig
								},
								{
									path: 'exchange',
									name: 'company.admin.setting.exchange',
									component: CompanyAdminSettingExchange
								}
							]
						}
					]
				},
				{
					path: 'leader',
					meta: { roles: ['leader'] },
					children: [
						{
							path: 'customer',
							meta: { breadcrumb: 'Clientes' },
							children: [
								{
									path: '',
									name: 'company.leader.customer.index',
									component: CompanyLeaderCustomerIndex
								}
							]
						}
					]
				}
			]
		},
		{
			path: '',
			redirect: '/home',
		},
		{
			path: '/:pathMatch(.*)*',
			component: NotFound
		}
	]
});

router.beforeEach(async (to, from) => {
	const offcanvasElement = document.querySelector('.offcanvas.show');
	if(offcanvasElement) Offcanvas.getInstance(offcanvasElement).hide();

	const modalElement = document.querySelector('.modal.show');
	if(modalElement) Modal.getInstance(modalElement).hide();

	const modalNavbar = document.querySelector('.navbar-collapse.show');
	if(modalNavbar) modalNavbar.classList.remove('show');

	if(to.meta?.needUser === true && !store.getters['auth/hasUser']) {
		store.dispatch('redirect/setNext', to.fullPath);
		return router.push({ name: 'auth.login' });
	}

	if(to.meta?.needUser === false && store.getters['auth/hasUser']) {
		store.dispatch('redirect/setNext', to.fullPath);
		return router.push({ name: 'home' });
	}

	/*
	if((to.meta?.roles ?? []).length > 0 && _.intersection(to.meta.roles, store.getters['auth/user'].roles).length == 0) {
		toast.error(`No tienes los permisos suficientes.`);
		return router.push({ name: 'home' });
	}
	*/
});

export default router;